import moment from 'moment'
import { TidewaysContext } from '../app/context'
import RangeModel from '../app/timeRange'
import { calcDays, Granularity } from '../domain/history/HistoryCriteria'
import { RangeSelectorInterface } from './RangeSelectorInterface'

export const rangeSelectorHistoryView = (
    tidewaysContext: TidewaysContext,
    navigator,
    granularity: Granularity,
    date: moment.Moment,
): RangeSelectorInterface => ({
    setDuration: duration => {
        navigator.replace({ granularity: duration })
    },
    setStartEnd: (start, end) => {
        const startDate = moment(start)
        const endDate = moment(end)

        const days = endDate.diff(startDate, 'days')

        let newGranularity = Granularity.day
        if (days > 2) {
            newGranularity = Granularity.week
        } else if (days > 7) {
            newGranularity = Granularity.month
        }

        navigator.replace({
            date: startDate.format('YYYY-MM-DD'),
            granularity: newGranularity,
        })
    },
    setService: service => {
        tidewaysContext.setService(service)
        updateRoute(tidewaysContext, navigator)
    },
    setEnvironment: environment => {
        tidewaysContext.setEnvironment(environment)
        updateRoute(tidewaysContext, navigator)
    },
    active: duration => duration === granularity,
    last: () => {
        navigator.replace({ date: getLastDate(granularity).format('YYYY-MM-DD') })
    },
    move: direction => {
        const newDate = date.clone()

        if (direction === 'next') {
            newDate.add(1, granularity)
        } else {
            newDate.subtract(1, granularity)
        }

        navigator.replace({ date: newDate.format('YYYY-MM-DD') })
    },
    isLast: () => {
        const lastDays = calcDays(getLastDate(granularity), granularity)
        const days = calcDays(date, granularity)

        return lastDays[0] === days[0]
    },
    supportsLiveData: false,
    supportsGraph: () => true,
    getRange: () => {
        const [first, ...days] = calcDays(date, granularity)
        let last = days.length > 0 ? days[days.length - 1] : first

        if (moment().diff(moment(last)) < 0) {
            last = moment().format('YYYY-MM-DD')
        }

        return RangeModel.fromStartAndEnd(first + ' 00:00:00', last + ' 23:59:59')
    },
    ranges: [
        { label: 'day', value: Granularity.day },
        { label: 'week', value: Granularity.week },
        { label: 'month', value: Granularity.month },
    ],
})

const updateRoute = (tidewaysContext: TidewaysContext, navigator) => {
    const route =
        tidewaysContext.route.route === 'XhprofProfilerBundle.History.operationHistory'
            ? 'XhprofProfilerBundle.History.history'
            : tidewaysContext.route.route

    navigator.replace(
        {
            ...tidewaysContext.toParameters(),
            m: null,
        },
        route,
    )
}

const getLastDate = (granularity: Granularity): moment.Moment => {
    switch (granularity) {
        case Granularity.day:
            return moment().subtract(1, 'd')
        case Granularity.week:
            return moment().subtract(1, 'w')
        case Granularity.month:
            return moment().subtract(1, 'm')
        default:
            throw Error('unknown granularity')
    }
}
